/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface ISwitch {
        id: number | string;
        name: string;
        port: number;
    }

    export class Switch implements ISwitch {
        public id: number | string;
        public name: string;
        public port: number;

        public static Empty(): Switch {
            return new Switch();
        }

        constructor() {
            this.id = undefined;
            this.name = '';
            this.port = undefined;
        }
    }


}